var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0303 12.4697C27.3232 12.7626 27.3232 13.2374 27.0303 13.5303L18.5607 22L27.0303 30.4697C27.3232 30.7626 27.3232 31.2374 27.0303 31.5303C26.7374 31.8232 26.2626 31.8232 25.9697 31.5303L16.9697 22.5303C16.6768 22.2374 16.6768 21.7626 16.9697 21.4697L25.9697 12.4697C26.2626 12.1768 26.7374 12.1768 27.0303 12.4697Z",
    fill: "#0F1125"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.7284c8b3fd4b6dd966d89aab39414bfd.svg";
export { ForwardRef as ReactComponent };